import API from '../api'

export default {
  getSubjectData ({commit}) {
	  API.getSubjectData().then(gradeTosubject => {
      commit('GET_SUBJECT_DATA', gradeTosubject)
	  }).catch(function (error) {
			commit('GET_SUBJECT_DATA', null)
	  	console.log(error)
	  });
	}
}
